var _excluded = ["className", "onChange", "value", "minDate", "maxDate"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useMemo, useState } from "react";
import AButton from "../AButton";
import AIcon from "../AIcon";
import { isDateBetweenRange, isDateTipOfRange, isSameDate, sortDates } from "./helpers";
import "./ADatePicker.scss";
var fullMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var ICON_SIZE = 10;
var ADatePicker = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? new Date() : _ref$value,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasMinDate = minDate instanceof Date;
  var hasMaxDate = maxDate instanceof Date;
  // Because date comparisons in this widget are ...
  // ... only concerned with the day, reset the ...
  // ... time to midnight for equal comparisons
  if (hasMinDate) {
    minDate.setHours(0, 0, 0, 0);
  }
  if (hasMaxDate) {
    maxDate.setHours(0, 0, 0, 0);
  }
  var isRange = Array.isArray(value);
  var _useState = useState(function () {
      var isRange = Array.isArray(value);
      if (!isRange) {
        return value;
      }

      // If range has a Date object, use the latest one
      // to initialize the calendar UI
      var dates = value.filter(function (d) {
        return d instanceof Date;
      });
      if (!dates.length) {
        return new Date();
      }
      return sortDates(dates)[dates.length - 1];
    }),
    _useState2 = _slicedToArray(_useState, 2),
    calendarDate = _useState2[0],
    setCalendarDate = _useState2[1];
  var firstCalendarDate = useMemo(function () {
    var currDate = new Date(calendarDate.getFullYear(), calendarDate.getMonth(), calendarDate.getDate() - calendarDate.getDay());
    while (currDate.getFullYear() >= calendarDate.getFullYear() && currDate.getMonth() >= calendarDate.getMonth() && currDate.getDate() > 1) {
      currDate.setDate(currDate.getDate() - 7);
    }
    return currDate;
  }, [calendarDate]);
  var className = "a-date-picker";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }), /*#__PURE__*/React.createElement("div", {
    className: "a-date-picker__header"
  }, /*#__PURE__*/React.createElement(AButton, {
    tertiaryAlt: true,
    icon: true,
    className: "a-date-picker__prev",
    onClick: function onClick() {
      setCalendarDate(new Date(calendarDate.getFullYear(), calendarDate.getMonth() - 1, 1));
    }
  }, /*#__PURE__*/React.createElement(AIcon, {
    size: ICON_SIZE
  }, "chevron-left")), /*#__PURE__*/React.createElement("div", {
    className: "a-date-picker__title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "a-date-picker__month"
  }, fullMonthNames[calendarDate.getMonth()]), " ", /*#__PURE__*/React.createElement("span", {
    className: "a-date-picker__year"
  }, calendarDate.getFullYear())), /*#__PURE__*/React.createElement(AButton, {
    tertiaryAlt: true,
    icon: true,
    className: "a-date-picker__next",
    onClick: function onClick() {
      setCalendarDate(new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1, 1));
    }
  }, /*#__PURE__*/React.createElement(AIcon, {
    size: ICON_SIZE
  }, "chevron-right"))), /*#__PURE__*/React.createElement("table", {
    className: "a-date-picker__calendar"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Sunday"
  }, "Su")), /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Monday"
  }, "Mo")), /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Tuesday"
  }, "Tu")), /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Wednesday"
  }, "We")), /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Thursday"
  }, "Th")), /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Friday"
  }, "Fr")), /*#__PURE__*/React.createElement("th", {
    className: "a-date-picker__week",
    scope: "col"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": "Saturday"
  }, "Sa")))), /*#__PURE__*/React.createElement("tbody", null, _toConsumableArray(Array(6)).map(function (x, i) {
    var sunday = new Date(+firstCalendarDate);
    sunday.setDate(sunday.getDate() + i * 7);
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, _toConsumableArray(Array(7)).map(function (y, j) {
      var currWeekDay = new Date(+sunday);
      currWeekDay.setDate(currWeekDay.getDate() + j);
      var isBeforeMinDate = hasMinDate && Date.parse(currWeekDay) < Date.parse(minDate);
      var isPastMaxDate = hasMaxDate && Date.parse(currWeekDay) > Date.parse(maxDate);
      var isDisabled = currWeekDay.getMonth() !== calendarDate.getMonth() || isBeforeMinDate || isPastMaxDate;
      var isSelected = isRange ? isDateTipOfRange(currWeekDay, value) : isSameDate(currWeekDay, value);
      var isBetweenRange = isRange && isDateBetweenRange(currWeekDay, value);
      return /*#__PURE__*/React.createElement("td", {
        key: j,
        className: "a-date-picker__day".concat(isDisabled ? " disabled" : "").concat(isSelected ? " selected" : "").concat(isBetweenRange ? " between" : "")
      }, isDisabled ? currWeekDay.getDate() : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "a-date-picker__day__label",
        onClick: function onClick() {
          onChange && onChange(currWeekDay);
        }
      }, currWeekDay.getDate()));
    }));
  }))));
});
var isValidDateTuple = function isValidDateTuple(range) {
  var isArray = Array.isArray(range);
  var isValidTypes = isArray && range.every(function (value) {
    return value instanceof Date || value === null;
  });
  var isValidLength = isValidTypes && range.length <= 2;
  return isArray && isValidDateTuple && isValidLength;
};
function rangeTupleValidator(propValue, key, componentName) {
  if (!isValidDateTuple(propValue)) {
    throw new Error("Invalid prop 'value' supplied to '" + componentName + "'. " + "When using a range, pass a tuple indicting a start and end " + "date, or 'null' if empty.");
  }
  return null;
}
ADatePicker.propTypes = {
  /**
   * Handles the `change` event for when a date is selected.
   */
  onChange: PropTypes.func,
  /**
   * Sets the selected date(s). If selecting a single date, a JavaScript
   * `Date` object should be passed. If selecting a date range, however,
   * then a two-item array should be supplied representing the starting
   * date and ending date. If either the starting date or ending date is
   * not yet selected, you should pass in the date as `null`.
   * @example supplying the starting date with an unselected ending date
   * value={[new Date(2022, 2, 28), null]}
   */
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.arrayOf(rangeTupleValidator)]),
  /**
   * The minimum date allowed for selection
   */
  minDate: PropTypes.instanceOf(Date),
  /**
   * The maximum date allowed for selection
   */
  maxDate: PropTypes.instanceOf(Date)
};
ADatePicker.displayName = "ADatePicker";
export default ADatePicker;